export default {
  /**
   * Returns the current authentication status, return true if the token is
   * not empty and the expiry is less than the current time
   *
   * @returns {boolean}
   */
  isAuthenticated: state => {
    return (
      state.token !== false &&
      state.token_expires > Math.round(Date.now() / 1000)
    )
  },
  /**
   * Returns authenticated users username/email (depends on what they used to
   * login with)
   * @returns {string|boolean}
   */
  getAuthUsername: state => {
    return state.username
  },
  /**
   * Return the user id of the currently authenticated user
   * @returns {number|boolean}
   */
  getAuthUserID: state => {
    return state.user_id
  },
  /**
   * Returns the current authenticated users refresh token
   * @returns {string|boolean}
   */
  getAuthRefreshToken: state => {
    return state.refresh_token
  },
  /**
   * Returns a timestamp for when the current users refresh authentication token expires
   * @returns {number|boolean}
   */
  getAuthRefreshTokenExpiry: state => {
    return state.refresh_token_expires
  },
  /**
   * Returns a timestamp for when the current users authentication token expires
   * @returns {number|boolean}
   */
  getAuthTokenExpiry: state => {
    return state.token_expires
  },
  /**
   * Return the current authentication token
   * @returns {string|boolean}
   */
  getAuthToken: state => {
    return state.token
  }
}
